import { render, staticRenderFns } from "./NotificationActionMessageModal.vue?vue&type=template&id=35d3a924&scoped=true&"
import script from "./NotificationActionMessageModal.vue?vue&type=script&lang=ts&"
export * from "./NotificationActionMessageModal.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationActionMessageModal.vue?vue&type=style&index=0&id=35d3a924&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d3a924",
  null
  
)

export default component.exports